
define(
	'Code25.CaterpartsGlobal.OEMMatch'
	, [
		"Utils", "Code25.CaterpartsGlobal.OEMMatch.View"
	]
	, function (
		Utils, Code25CaterpartsGlobalOEMMatchView
	) {
		'use strict';

		return {
			mount: function mount(container) {
				function createOEMMatch() {
					var pdp = container.getComponent('PDP');
					return new Code25CaterpartsGlobalOEMMatchView({ model: this.model,pdp:pdp });
				}
				if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {
					var ProductDetailsView = require("ProductDetails.Full.View");
					if (ProductDetailsView) {
						ProductDetailsView.prototype.childViews['OEMMatch'] = createOEMMatch;
					}

					ProductDetailsView = require("ProductDetails.QuickView.View");
					if (ProductDetailsView) {
						ProductDetailsView.prototype.childViews['OEMMatch'] = createOEMMatch;
					}

					ProductDetailsView = require("Cart.Lines.View");
					if (ProductDetailsView) {
						ProductDetailsView.prototype.childViews['OEMMatch'] = createOEMMatch;
					}

				}
				if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {

					var NavigationView = require("Transaction.Line.Views.Cell.Navigable.View");
					if(NavigationView.TransactionLineViewsCellNavigableView){
						NavigationView=NavigationView.TransactionLineViewsCellNavigableView;
					}
					if (NavigationView) {
						NavigationView.prototype.childViews['OEMMatch'] = createOEMMatch;
					}
				}

				
			}
		}

	});
